var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#515151;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logado",
    transform: "translate(-56.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M96,30c0-11-9-20-20-20s-20,9-20,20c0,5.6,2.4,10.7,6.1,14.4c0.1,0.1,0.2,0.2,0.3,0.3 C66,48,70.8,50,76,50s10-2,13.6-5.3c0.1-0.1,0.2-0.2,0.3-0.3C93.6,40.7,96,35.6,96,30z M76,12.5c9.7,0,17.5,7.9,17.5,17.5 c0,4.1-1.4,7.9-3.8,10.8c-1.1-3.5-4.2-6.2-8.4-7.5c2.3-1.7,3.8-4.3,3.8-7.4c0-5-4.1-9.1-9.1-9.1s-9.1,4.1-9.1,9.1 c0,3,1.5,5.7,3.8,7.4c-4.2,1.3-7.3,4-8.4,7.5c-2.4-3-3.8-6.7-3.8-10.8C58.5,20.4,66.3,12.5,76,12.5z M69.4,26 c0-3.6,3-6.6,6.6-6.6s6.6,3,6.6,6.6s-3,6.6-6.6,6.6S69.4,29.6,69.4,26z M64.4,43.1c0.4-4.6,5.2-8,11.6-8s11.2,3.4,11.6,8 c-3.1,2.8-7.2,4.4-11.6,4.4S67.5,45.8,64.4,43.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2b26eca9662efec7891f628a9290701c.svg";
export { ForwardRef as ReactComponent };